<template>
  <v-dialog
    v-bind="$attrs"
    class="base-dialog-box"
    content-class="white base-dialog-box--modal"
    :width="width ?? 'auto'"
    overlay-color="var(--v-black-base)"
    overlay-opacity=".15"
  >
    <slot />
  </v-dialog>
</template>

<script setup lang="ts">
import { VDialog } from 'vuetify/components'

defineProps<{ width?: string | number }>()
</script>
